import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import type { RootState } from './store';
import { getOtp } from "../api/otp.api";

// // Define a type for the slice state


interface otpState {
  token: string;
  loading: boolean;
  error: string;
}
// Define the initial state using that type
const initialState: otpState = {
  token: '',
  loading: false,
  error: '',
};

export const fetchOtp = createAsyncThunk(
  'getOtp',
  async (payload:string,thunkApi) => {
    return getOtp(payload).then(response => {
      //console.log(response);
      return response;
      
    })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const otpContainerSlice = createSlice({
  name: 'otp',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchOtp.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchOtp.fulfilled, (state,action) => {
      state.loading = false;
      state.token = action.payload.token;
    });
    builder.addCase(fetchOtp.rejected, (state, action) => {
      console.log('action====>', action);
      state.error = action.toString();

      state.loading = false;
    });
  },
});

// Other code such as selectors can use the imported `RootState` type
export const otpData = (state: RootState): string => state.otpReducer.token;
export const errorInPhonenumber = (state: RootState): string => state.otpReducer.error;
export const phoneNumberIsloading = (state: RootState): boolean => state.otpReducer.loading;

export default otpContainerSlice.reducer;
